import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import {
  AdminRouteEnum,
  BaseRouteEnum,
  PMSRouteEnum,
} from '../../enums/route.enum';
import { AuthService } from '../../services/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authState = inject(AuthService);
  if (authState.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([BaseRouteEnum.LOGIN], {
    queryParams: { returnUrl: state.url },
  });
};
